Pegasus.IOManager = Em.Object.create({
  model: null,
  generateOutput: function(forSending, callback){
    Pegasus.lookupController('frameCommManager').send('requestTemplateOutput', forSending, function(result){
      if ( callback ) {
        callback(result);
      }
    });
  },
  generateLandingPageTemplate: function(imageDirectory, imageNameOffset){
    var message = this.generateOutput().editor_cookie;
    var messageElement = message.toDOM();
    var $message = $(messageElement);
    $message.find('[data-vr-structure-web-template-region], [data-vr-structure-web-template-cell]').removeAttr('style');
    var images = [];
    var im;

    $message.find('[data-background-image]').each( function(i, item) {
      im = $(item).attr('data-background-image');
      if ( im ) {
        images.addObject( im );
      }
    });

    $message.find('[data-src]').each( function(i, item) {
      im = $(item).attr('data-src');
      if ( im ) {
        images.addObject( im );
      }
    });

    $message.find('[data-default-image]').each( function(i, item) {
      im = $(item).attr('data-default-image');
      if ( im.search('http') === 0 ) {
        images.addObject( im );
      }
    });

    var contentType, convertData, name, reduceMap = {}, self = this;

    var exported = $message[0].outerHTML;

    var completed = 0;

    if ( images.length ) {
      images.forEach(function(image, index) {
        window.convertToDataURLviaCanvas( image, function(data){
          contentType = data.encoded.split(",")[0].split(":")[1].split(";")[0];
          convertData = data.encoded.split(',').get('lastObject');
          name = index + imageNameOffset + "." + contentType.split('/')[1];
          var regString = image.split('?').length > 1 ? image.split('?')[0] + "\\?" + image.split('?')[1] : image;
          var reg = new RegExp( regString, 'g' );
          window.saveImage( b64ToBlob(convertData), name, contentType );
          exported = exported.replace(reg, "{SERVER_URL}/pegasus/assets/themelp1/" + imageDirectory + '/' + name);

          completed++;

          if ( completed === images.length ) {
            self.didReplaceLandingPageImages(exported);
          }
        }, Em.K );
      });
    } else {
      this.didReplaceLandingPageImages(exported);
    }
  },

  generateEmailTemplate: function(imageDirectory, imageNameOffset){
    var message = this.generateOutput().editor_cookie;
    var messageElement = message.toDOM();
    var $message = $(messageElement);
    $message.find('[data-vr-structure-region], [data-vr-structure-cell]').removeAttr('style');
    var images = [];
    var im;

    $message.find('[data-background-image]').each( function(i, item) {
      im = $(item).attr('data-background-image');
      if ( im ) {
        images.addObject( im );
      }
    });

    $message.find('[data-src]').each( function(i, item) {
      im = $(item).attr('data-src');
      if ( im ) {
        images.addObject( im );
      }
    });

    $message.find('[data-default-image]').each( function(i, item) {
      im = $(item).attr('data-default-image');
      if ( im.search('http') === 0 ) {
        images.addObject( im );
      }
    });

    var contentType, convertData, name, reduceMap = {}, self = this;

    var exported = $message[0].outerHTML;

    var completed = 0;

    if ( images.length ) {
      images.forEach(function(image, index) {
        convertToDataURLviaCanvas( image, function(data){
          contentType = data.encoded.split(",")[0].split(":")[1].split(";")[0];
          convertData = data.encoded.split(',').get('lastObject');
          name = index + imageNameOffset + "." + contentType.split('/')[1];
          var regString = image.split('?').length > 1 ? image.split('?')[0] + "\\?" + image.split('?')[1] : image;
          var reg = new RegExp( regString, 'g' );
          window.saveImage( b64ToBlob(convertData), name, contentType );
          exported = exported.replace(reg, "{SERVER_URL}/pegasus/assets/tech/" + imageDirectory + '/' + name);

          completed++;

          if ( completed === images.length ) {
            self.didReplaceEmailImages(exported);
          }
        });
      });
    } else {
      this.didReplaceEmailImages(exported);
    }
  },

  didReplaceEmailImages: function(message){
    var m = $(message);
    m.find('img').remove();
    m.find('[id]').removeAttr('id');
    m.find('.button-show-block-content').find('table').remove();
    m.find('[data-vr-structure-padding-top], [data-vr-structure-padding-bottom]').removeAttr('style');
    m.find('[data-form-name]').attr('data-form-name', '').attr('data-form-list-id', '');
    m.find('[data-default-image]').each( function(index, item){
      $(item).attr('data-default-image', $(item).attr('data-default-image').replace("{SERVER_URL}/pegasus/assets/tech/", '') );
    });
    m.find('[data-src]').each( function(index, item){
      $(item).attr('data-default-image', $(item).attr('data-src').replace("{SERVER_URL}/pegasus/assets/tech/", '') );
    });
    m.find('[data-src]').removeAttr('data-src');
    m.find('.vr-web-template-form-wrapper').remove();

    console.log( m[0].outerHTML );
  },

  didReplaceLandingPageImages: function(message){
    var m = $(message);
    m.find('img').remove();
    m.find('[id]').removeAttr('id');
    m.find('.button-show-block-content').find('table').remove();
    m.find('[data-vr-structure-padding-top], [data-vr-structure-padding-bottom]').removeAttr('style');
    m.find('[data-form-name]').attr('data-form-name', '').attr('data-form-list-id', '');
    m.find('[data-default-image]').each( function(index, item){
      $(item).attr('data-default-image', $(item).attr('data-default-image').replace("{SERVER_URL}/pegasus/assets/themelp1/", '') );
    });
    m.find('[data-src]').each( function(index, item){
      $(item).attr('data-default-image', $(item).attr('data-src').replace("{SERVER_URL}/pegasus/assets/themelp1/", '') );
    });
    m.find('[data-src]').removeAttr('data-src');
    m.find('.vr-web-template-form-wrapper').remove();
    m.find('table tbody').remove();

    console.log( m[0].outerHTML );
  },

  createFromExternal: function(){
    return this.get('model').createFromExternal();
  },
  buildModelForContext: function(context) {
    var record = Pegasus.lookupStore().createRecord( this[context](), {});
    this.set('model', record);
  },
  capture: function(){
    return Pegasus.CaptureTemplate;
  },
  landing_page: function(){
    return Pegasus.WebTemplate;
  },
  email: function(){
    return Pegasus.EmailTemplate
  }
});
